'use client';

import { Easing, motion } from 'framer-motion';
import { usePathname } from 'next/navigation';
import { ReactNode } from 'react';

const slideToLeft = {
  initial: { x: 20, opacity: 0 },
  animate: { x: 0, opacity: 1 },
  exit: {
    x: -20,
    opacity: 0,
    transition: {
      ease: 'easeInOut' as Easing,
      duration: 0.75,
    },
  },
  transition: { ease: 'easeInOut' as Easing, duration: 0.75 },
};

interface StepTransitionProps {
  children?: ReactNode;
  className?: string;
}

const StepTransition = ({ children, className }: StepTransitionProps) => {
  const pathname = usePathname();

  return (
    <motion.div className={className} key={pathname} {...slideToLeft}>
      {children}
    </motion.div>
  );
};

export default StepTransition;
